<template>
  <img v-if="item.has_avatar || item.avatar" class="avatar_placeholder" :src="returnCropedImage" alt="" />
  <div v-else class="avatar_placeholder"></div>
</template>

<script>
export default {
  name: 'employerAvatar',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    returnCropedImage() {
      let imageArr = []

      if (this.item.avatar) {
        imageArr = this.item.avatar.split('/')
      } else if (this.item.employer_avatar) {
        imageArr = this.item.employer_avatar.split('/')
      } else {
        return ''
      }

      const image = imageArr.pop()
      const imageName = image.split('.')[0]
      const imageExtension = image.split('.')[1]

      return `${this.$config.cdnServer}/images/${imageName}@${this.width}x${this.height}.${imageExtension}`
    },
  },
}
</script>
